

























































































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class RoundModalTracking extends Vue {
  @Prop() readonly trackingList!: any;

  @Prop() readonly openModalTracking!: Function;

  @Prop() readonly fetchResult!: Function;

  @Prop() readonly checkStatusRound!: Function;

  utilsInstance = utils;

  handleModalCancel(items, typeModal) {
    this.openModalTracking(items, typeModal);
  }
}
